import {EventBus} from "../../../common/ts/events/EventBus";
import dom, {} from "../../../common/ts/core/dom";
import {
    BUILDING_FEATURE_ITEM_SELECTOR,
    PROPERTY_FEATURE_ITEM_SELECTOR,
    VIEW_MORE_BUILDING_FEATURES_SELECTOR,
    VIEW_MORE_PROPERTY_FEATURES_SELECTOR
} from "./constants";
import {HIDDEN_CLASS} from "../../../common/ts/components/description/constants";

export default class FeaturesComponent {
    private eventBus = EventBus.getInstance();
    private viewMorePropertyFeaturesButton = dom.select(VIEW_MORE_PROPERTY_FEATURES_SELECTOR);
    private viewMoreBuildingFeaturesButton = dom.select(VIEW_MORE_BUILDING_FEATURES_SELECTOR);

    constructor() {
        this.setupEventListeners();
    }

    static init = () => {
        new FeaturesComponent()
    };

    private setupEventListeners = () => {
        if (this.viewMorePropertyFeaturesButton) {
            this.eventBus.emit(
                new dom.AddClickListenerEvent({
                    selector: VIEW_MORE_PROPERTY_FEATURES_SELECTOR,
                    listener: () => this.expandFeatures(PROPERTY_FEATURE_ITEM_SELECTOR, VIEW_MORE_PROPERTY_FEATURES_SELECTOR),
                }),
            );
        }
        if (this.viewMoreBuildingFeaturesButton) {
            this.eventBus.emit(
                new dom.AddClickListenerEvent({
                    selector: VIEW_MORE_BUILDING_FEATURES_SELECTOR,
                    listener: () => this.expandFeatures(BUILDING_FEATURE_ITEM_SELECTOR, VIEW_MORE_BUILDING_FEATURES_SELECTOR),
                }),
            );
        }
    };

    private expandFeatures(itemSelector: string, buttonSelector: string) {
        const featureItem = dom.selectAll(itemSelector);
        featureItem.forEach((feature) => {
            feature.classList.remove(HIDDEN_CLASS);
        });
        this.eventBus.emit(new dom.AddClassEvent({selector: buttonSelector, className: HIDDEN_CLASS}));
    }
}
